import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import type { AccommodationFacility } from '@data-access/graphql/schema.types';
import type { AccommodationFragment } from 'src/lib/backend/documents/accommodation';
import { FacilitiesList } from './facilities-list';
import { FacilitiesModal } from './facilities-modal';
type AccommodationFacilitiesProps = {
  accommodation: AccommodationFragment & {
    facilityHighlights: AccommodationFacility[];
  };
};
const GRID_ROWS_PER_COLUMN = ['sm:grid-rows-[repeat(1,auto)]', 'sm:grid-rows-[repeat(2,auto)]', 'sm:grid-rows-[repeat(3,auto)]', 'sm:grid-rows-[repeat(4,auto)]', 'sm:grid-rows-[repeat(5,auto)]'];
export function AccommodationFacilities(t0) {
  const $ = _c(10);
  const {
    accommodation
  } = t0;
  if (!accommodation) {
    return null;
  }
  const t1 = accommodation.facilityHighlights;
  const t2 = GRID_ROWS_PER_COLUMN[Math.ceil(accommodation.facilityHighlights.length / 2) - 1];
  let t3;
  if ($[0] !== t2) {
    t3 = cx("hyphens-auto sm:grid sm:grid-flow-col sm:grid-cols-2 sm:gap-x-8 sm:gap-y-6 max-sm:[&>*:nth-child(n+6)]:hidden", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== accommodation.facilityHighlights || $[3] !== t3) {
    t4 = <FacilitiesList facilities={t1} className={t3} />;
    $[2] = accommodation.facilityHighlights;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== accommodation) {
    t5 = <FacilitiesModal accommodation={accommodation} />;
    $[5] = accommodation;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className="flex flex-col items-start gap-6 sm:gap-8">{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}